import { createContext, useContext } from 'react';

export const ProtocolPanelContext = createContext({
  closePanel: () => {},
  navigateToEcg: () => {},
  consultationRecordUid: null,
  consultationUid: null,
  locationType: null,  // 'accepted' | 'completed' | 'client'
  isReadOnly: true
});

export const useProtocolPanel = () => useContext(ProtocolPanelContext);
